import { render, staticRenderFns } from "./H5Partners.vue?vue&type=template&id=fa869de6"
import script from "./H5Partners.vue?vue&type=script&lang=js"
export * from "./H5Partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa869de6')) {
      api.createRecord('fa869de6', component.options)
    } else {
      api.reload('fa869de6', component.options)
    }
    module.hot.accept("./H5Partners.vue?vue&type=template&id=fa869de6", function () {
      api.rerender('fa869de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5Partners.vue"
export default component.exports